import React from 'react'
import DisplayImagepointsAndpeorid from './DisplayImagepointsAndpeorid'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'

function PointsOverRideAccordianComponent(props) {
  const {
    onRemove,
    selectedContentType,
    setTrendingTopMovies,
    setTrendingTopPersons,
    setTrendingTopWebseries,
    openAccordionIndex,
    toggleAccordion,
    Topmovies,
    TopPersons,
    TopWebserises,
    trendingTopMovies,
    trendingTopPersons,
    trendingTopWebseries,
    AutoSuggestionSelectedOption,
    toggleSearchBar,
  } = props
  return (
    <Accordion>
      <AccordionItem
        isOpen={openAccordionIndex === 0}
        onClick={() => toggleAccordion(0, 'movie', 'Trending')}
      >
        <AccordionItemHeading>
          <AccordionItemButton>Movies</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <form>
            <label>Movies:</label>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <label>Movie Id</label>
              <label>Movie Name</label>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {Topmovies.map((e, index) => (
                <>
                  <DisplayImagepointsAndpeorid
                    e={e}
                    index={index}
                    imageSrc={e.poster}
                    id={e.id || e.movieID || e.personID}
                    initialPoints={e.points}
                    title={e.name_En || e.title_En}
                    recordType={e.recordType}
                    selectedContentType={selectedContentType}
                    AutoSuggestionSelectedOption={AutoSuggestionSelectedOption}
                    type={'movies'}
                    items={Topmovies}
                  />
                </>
              ))}
            </div>
            <button type='button' className='btn btn-primary' onClick={() => toggleSearchBar()}>
              ADD
            </button>
          </form>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem
        isOpen={openAccordionIndex === 1}
        onClick={() => toggleAccordion(1, 'person', 'Trending')}
      >
        <AccordionItemHeading>
          <AccordionItemButton>Persons</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <form>
            <label>Persons:</label>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <label>Person Id</label>
              <label>Person Name</label>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {TopPersons.map((e, index) => (
                <>
                  <DisplayImagepointsAndpeorid
                    e={e}
                    index={index}
                    imageSrc={e.poster}
                    id={e.id || e.movieID || e.personID}
                    initialPoints={e.points}
                    title={e.name_En || e.title_En}
                    recordType={e.recordType}
                    selectedContentType={selectedContentType}
                    AutoSuggestionSelectedOption={AutoSuggestionSelectedOption}
                    type={'person'}
                    items={TopPersons}
                  />
                </>
              ))}
            </div>
            <button type='button' className='btn btn-primary' onClick={() => toggleSearchBar()}>
              ADD
            </button>
          </form>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem
        isOpen={openAccordionIndex === 2}
        onClick={() => toggleAccordion(2, 'webseries', 'Trending')}
      >
        <AccordionItemHeading>
          <AccordionItemButton>Web Series</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <form>
            <label>Web Series:</label>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <label>webseries Id</label>
              <label>webseries Name</label>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {TopWebserises.map((e, index) => (
                <>
                  <DisplayImagepointsAndpeorid
                    e={e}
                    index={index}
                    imageSrc={e.poster}
                    id={e.id || e.movieID || e.personID}
                    initialPoints={e.points}
                    title={e.name_En || e.title_En}
                    recordType={e.recordType}
                    selectedContentType={selectedContentType}
                    AutoSuggestionSelectedOption={AutoSuggestionSelectedOption}
                    type={'webseries'}
                    items={TopWebserises}
                  />
                </>
              ))}
            </div>
            <button type='button' className='btn btn-primary' onClick={() => toggleSearchBar()}>
              ADD
            </button>
          </form>
        </AccordionItemPanel>
      </AccordionItem>
      <label>manuallyUpdatedTrendingData</label>
      <AccordionItem
        isOpen={openAccordionIndex === 3}
        onClick={() => toggleAccordion(3, 'movie', 'manual')}
      >
        <AccordionItemHeading>
          <AccordionItemButton>Movies</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <form>
            <label>Movies:</label>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <label>Movie Id</label>
              <label>Movie Name</label>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {trendingTopMovies.map((e, index) => (
                <>
                  <DisplayImagepointsAndpeorid
                    e={e}
                    index={index}
                    imageSrc={e.poster}
                    id={e.id || e.movieID || e.personID}
                    initialPoints={e.points}
                    title={e.name_En || e.title_En}
                    recordType={e.recordType}
                    manuallyUpdatedTrendingData={'manuallyUpdatedTrendingData'}
                    onRemove={onRemove}
                    selectedContentType={selectedContentType}
                    AutoSuggestionSelectedOption={AutoSuggestionSelectedOption}
                    type={'movies'}
                    items={trendingTopMovies}
                    handleItems={setTrendingTopMovies}
                  />
                </>
              ))}
            </div>
            <button type='button' className='btn btn-primary' onClick={() => toggleSearchBar()}>
              ADD
            </button>
          </form>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem
        isOpen={openAccordionIndex === 4}
        onClick={() => toggleAccordion(4, 'person', 'manual')}
      >
        <AccordionItemHeading>
          <AccordionItemButton>Persons</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <form>
            <label>Persons:</label>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <label>Person Id</label>
              <label>Person Name</label>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {trendingTopPersons.map((e, index) => (
                <>
                  <DisplayImagepointsAndpeorid
                    e={e}
                    index={index}
                    imageSrc={e.poster}
                    id={e.id || e.movieID || e.personID}
                    initialPoints={e.points}
                    title={e.name_En || e.title_En}
                    recordType={e.recordType}
                    manuallyUpdatedTrendingData={'manuallyUpdatedTrendingData'}
                    onRemove={onRemove}
                    selectedContentType={selectedContentType}
                    AutoSuggestionSelectedOption={AutoSuggestionSelectedOption}
                    type={'person'}
                    items={trendingTopPersons}
                    handleItems={setTrendingTopPersons}
                  />
                </>
              ))}
            </div>
            <button type='button' className='btn btn-primary' onClick={() => toggleSearchBar()}>
              ADD
            </button>
          </form>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem
        isOpen={openAccordionIndex === 5}
        onClick={() => toggleAccordion(5, 'webseries', 'manual')}
      >
        <AccordionItemHeading>
          <AccordionItemButton>Web Series</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <form>
            <label>Web Series:</label>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <label>webseries Id</label>
              <label>webseries Name</label>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {trendingTopWebseries.map((e, index) => (
                <>
                  <DisplayImagepointsAndpeorid
                    e={e}
                    index={index}
                    imageSrc={e.poster}
                    id={e.id || e.movieID || e.personID}
                    initialPoints={e.points}
                    title={e.name_En || e.title_En}
                    recordType={e.recordType}
                    manuallyUpdatedTrendingData={'manuallyUpdatedTrendingData'}
                    onRemove={onRemove}
                    selectedContentType={selectedContentType}
                    AutoSuggestionSelectedOption={AutoSuggestionSelectedOption}
                    type={'webseries'}
                    items={trendingTopWebseries}
                    handleItems={setTrendingTopWebseries}
                  />
                </>
              ))}
            </div>
            <button type='button' className='btn btn-primary' onClick={() => toggleSearchBar()}>
              ADD
            </button>
          </form>
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  )
}

export default PointsOverRideAccordianComponent
